export default __webpack_public_path__ + "assets/0208b1582ca7bc834586f22ea5ad1601.jpeg";